<script>
    import { onMount } from "svelte";
    import { user, hiddenMenus } from "/stores";
    import { menuFavorites, loadMenuFavorites, reorderMenuFavorites } from "/stores/menuFavorites.js";
    import { showAlert } from "/stores/alert.js";
    import { PARTNER_MENU_BY_PATH } from "/common/partnerMenuItems.js";
    import { isMenuVisible } from "/common/permissions.js";

    let loadFailed = false;
    let draggingPath = null;
    let dragOverPath = null;
    let saving = false;
    $: visibleFavorites = $menuFavorites
        .map((path) => PARTNER_MENU_BY_PATH.get(path))
        .filter((item) => item && !$hiddenMenus.has(item.groupKey) && isMenuVisible(item.path, $hiddenMenus, $user.Type));

    function startDrag(event, path) {
        draggingPath = path;
        dragOverPath = null;
        event.dataTransfer.effectAllowed = "move";
        // 링크를 그대로 드래그하면 브라우저가 주소 이동으로 처리하므로 경로만 담는다.
        event.dataTransfer.setData("text/plain", path);
    }

    function dragOver(event, path) {
        if (!draggingPath || draggingPath === path) return;
        event.preventDefault();
        event.dataTransfer.dropEffect = "move";
        dragOverPath = path;
    }

    function endDrag() {
        draggingPath = null;
        dragOverPath = null;
    }

    async function drop(event, path) {
        event.preventDefault();
        if (saving || !draggingPath || draggingPath === path) return;

        const paths = visibleFavorites.map((item) => item.path);
        const from = paths.indexOf(draggingPath);
        const to = paths.indexOf(path);
        if (from < 0 || to < 0) return;
        const [moved] = paths.splice(from, 1);
        paths.splice(to, 0, moved);

        saving = true;
        try {
            await reorderMenuFavorites(paths);
        } catch (error) {
            await showAlert(error.message || "즐겨찾기 순서를 저장할 수 없습니다.");
        } finally {
            saving = false;
        }
    }

    onMount(async () => {
        try {
            await loadMenuFavorites($user.ID);
        } catch (error) {
            console.error("즐겨찾기 불러오기 실패:", error);
            loadFailed = true;
        }
    });
</script>

{#if visibleFavorites.length > 0}
<div id="favorite-menu-bar" class="favorite-menu-bar" role="navigation" aria-label="즐겨찾기 바로가기">
    {#each visibleFavorites as item (item.path)}
        <a
            class="favorite-menu-link"
            class:dragging={draggingPath === item.path}
            class:drag-over={dragOverPath === item.path}
            href={item.path}
            title="드래그해서 순서를 바꿀 수 있습니다."
            draggable="true"
            on:dragstart={(event) => startDrag(event, item.path)}
            on:dragover={(event) => dragOver(event, item.path)}
            on:drop={(event) => drop(event, item.path)}
            on:dragend={endDrag}
        >{item.label}</a>
    {/each}
</div>
{:else if loadFailed}
<div class="favorite-menu-bar-error" role="status">즐겨찾기를 불러오지 못했습니다.</div>
{/if}
